import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from "react";
import iconSizes from "../iconSizes";
import { deprecatedPropValueMessage } from "../../../utils/deprecationUtils";
var isDeprecatedIconSize = function(iconSize) {
    if (typeof iconSize === 'undefined') {
        return false;
    }
    return iconSize === 'xl';
};
var WifiOffIcon = function(param) {
    var _size = param.size, size = _size === void 0 ? 's' : _size, _color = param.color, color = _color === void 0 ? 'currentColor' : _color, title = param.title;
    if (isDeprecatedIconSize(size)) {
        deprecatedPropValueMessage({
            componentName: 'Icon',
            propName: 'size',
            propValue: 'xl',
            date: 'Q3 2022'
        });
    }
    var ref;
    return _jsxs("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: '0 0 32 32',
        css: {
            width: iconSizes[size],
            height: iconSizes[size],
            fill: color
        },
        role: "img",
        "aria-hidden": (ref = !title) !== null && ref !== void 0 ? ref : false,
        children: [
            title && _jsx("title", {
                children: title
            }),
            _jsx("g", {
                children: _jsxs("svg", {
                    viewBox: "0 0 24 24",
                    children: [
                        _jsx("path", {
                            d: "M1.707.293l22 22a1 1 0 11-1.414 1.414l-6.64-6.64a.998.998 0 01-.853-.167c-1.647-1.236-3.97-1.236-5.719.014a1 1 0 11-1.162-1.628 6.988 6.988 0 014.67-1.285l-2.722-2.72c-1.474.323-2.938 1.056-4.242 2.1a1 1 0 11-1.25-1.562c1.192-.953 2.507-1.691 3.871-2.158L5.875 7.29A16.697 16.697 0 002.05 9.76 1 1 0 01.749 8.24a18.823 18.823 0 013.63-2.445L.294 1.707A1 1 0 011.707.293zM12 19.5a1.5 1.5 0 110 3 1.5 1.5 0 010-3zm5.147-9.294a12.31 12.31 0 012.504 1.635 1 1 0 01-1.302 1.518 10.333 10.333 0 00-2.096-1.365 1 1 0 01.894-1.788zm6.113-1.957a1 1 0 11-1.32 1.502c-3.088-2.713-7.114-4.03-11.147-3.655a1 1 0 01-.186-1.992c4.583-.426 9.153 1.07 12.653 4.145z"
                        }),
                        _jsxs("g", {
                            fillRule: "evenodd",
                            children: [
                                _jsx("use", {}),
                                _jsx("use", {
                                    fillRule: "nonzero"
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
WifiOffIcon.isCarinaIcon = true;
export default WifiOffIcon;
